import React, { useState } from "react";
import "./FormFieldsStyle.css";

const InputField14s = (props) => {
    const {item} = props
    const letter = (() => {
        try {
            return JSON.parse(item?.data);
        } catch (e) {
            return item?.data;
        }
    })()

    const [isSpecialError, setIsSpecialError] = useState("");
    const [isLimitError, setIsLimitError] = useState("");
    const [inputValue, setInputValue] = useState(
        (props.userInputObj && props.userInputObj.key1) || ""
    );

    const handleChange = (e) => {
        let value = e.target.value;

        // Prevent input from starting with a space
        if (value.startsWith(" ")) return;

        // Restrict the length to 100 characters
        if (value.length > `${letter?.limit}`) {
            setIsLimitError(`Maximum character limit is ${letter?.limit}`);
            return;
        } else {
            setIsLimitError("");
        }


        // Update state and save valid input to localStorage
        setInputValue(value);
        props?.setErrors((prevErrors) => ({
            ...prevErrors,
            [props?.index]: { key1: e.target.value, displayName: e.target.value }, 
            
        }));
        localStorage.setItem("inputValue", JSON.stringify({ key1: value }));
    };

    return (
        <div className="form-group">
            <label className="sel" style={{ fontSize: "16px", color: "#444444" }}>
                <span className="asterisk-icon"></span>
            </label>
            {/* <input
        type="text"
        className="form-control"
        placeholder="Enter Description"
        disabled={props.disable}
        value={inputValue}
        onChange={handleChange}
        style={{ marginLeft: "6px" }}
      /> */}
            <textarea
                className={`form-control error-${props?.index}`}
                placeholder={ "Enter Description"}
                disabled={props.disable}
                value={inputValue}
                onChange={handleChange}
                style={{
                    marginLeft: "6px",
                    width: "90%",
                    height: "100px",  // Adjust height for better visibility
                    whiteSpace: "pre-wrap", // Ensures text wraps properly
                    overflowWrap: "break-word" // Breaks long words into new lines
                }}
            ></textarea>

            <span className="validate">&nbsp;</span>
            <div style={{ color: "red", marginBottom: "12px", fontSize: 12, marginLeft: "10px" }}>
                {isSpecialError || isLimitError}
            </div>
        </div>
    );
};

export default InputField14s;
